import {
	DATE_INPUT_MAX,
	DATE_INPUT_MIN,
	sanitizeDateInputChange,
	todayInputValue,
} from "../../utils/dateInput.util";

/**
 * Native date input with year bounds and calendar-validity checks.
 * Rejects 6+ digit years and impossible dates (e.g. 31 Feb).
 */
export default function DateInput({
	value = "",
	onChange,
	min = DATE_INPUT_MIN,
	max: maxProp,
	pastOnly = false,
	className = "form-control form-control-sm",
	style,
	...rest
}) {
	// pastOnly is for filters over recorded data: nothing has happened in the future yet.
	const max = maxProp ?? (pastOnly ? todayInputValue() : DATE_INPUT_MAX);
	const handleChange = (e) => {
		const next = sanitizeDateInputChange(e.target.value, min, max);
		if (next === null) return;
		onChange?.(next);
	};

	return (
		<input
			type="date"
			className={className}
			style={style}
			min={min}
			max={max}
			value={value}
			onChange={handleChange}
			{...rest}
		/>
	);
}
